// extracted by mini-css-extract-plugin
export var formContainer = "_bu-0";
export var message = "_bu-1";